const LinkedAssetsColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, width: `calc(100% - 310px)` } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "mediaType",
        label: "Media type",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 110 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const VideoAssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 396px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: false,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const AudioAssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { pl: 0, width: "calc(100% - 396px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: false,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const ImageAssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 276px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "type",
        label: "Type",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const CaptionAssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 236px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "type",
        label: "Type",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const FileAssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 276px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: false,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const PreviewAssetColumn = [
    {
        id: "name",
        label: "Name",
        style: {
            custom: { flex: 1, width: `calc(100% - 120px)`, margin: "8px 8px 12px 12px" },
            thumbnail: { width: 88, height: 88 },
        },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

export {
    LinkedAssetsColumn,
    AudioAssetColumn,
    CaptionAssetColumn,
    FileAssetColumn,
    ImageAssetColumn,
    VideoAssetColumn,
    PreviewAssetColumn,
};
